import { useGetInventorySnapshot } from "@/api/useInventory"
import { useGetStatistics } from "@/api/useStatistics"
import { useFeatureFlags } from "@/hooks/useUser"
import { useFunnelTriage } from "@/pages/TriagePage/components/organisms/FunnelTriagePage"
import { snapshotInventoryPropsSelector } from "../selectors/inventory.selector"
import { statisticsSelector } from "../selectors/statistics.selector"

import type { DashboardProps } from "./useDashboard.types"

const useDashboard = (): DashboardProps => {
  const postureResponse = useGetStatistics(
    { needle: "/posture_score" },
    { select: statisticsSelector }
  )

  const kortexInstalledFF = useFeatureFlags("kortexInstalled")

  const inventorySnapshotResponse = useGetInventorySnapshot(undefined, {
    select: snapshotInventoryPropsSelector
  })

  const funnelContext = useFunnelTriage()
  const runtime = kortexInstalledFF

  return {
    runtime,
    postureProps: postureResponse,
    inventorySnapshotProps: inventorySnapshotResponse,
    funnelProps: {
      context: funnelContext,
      isLoading: funnelContext[4].isLoading
    }
  }
}

export default useDashboard
